import React from 'react';
import styled from 'styled-components';
import { Switch, Redirect } from 'react-router-dom';
import { ProtectedRoute } from '@catapultxos/sso-auth';

import UsersPage from '../pages/Users';
import ProductsPage from '../pages/Products';
import OrgsPage from '../pages/Orgs';

const ContentAreaContainer = styled.div`
  flex: 1;
  margin-right: 30px;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  padding-bottom: 30px;
`;

function ContentArea() {
  return (
    <ContentAreaContainer id="ContentArea">
      <Switch>
        <ProtectedRoute path="/users" component={UsersPage} loginURL={process.env.REACT_APP_SSO_UI_LOGIN_URL} />
        <ProtectedRoute path="/products" component={ProductsPage} loginURL={process.env.REACT_APP_SSO_UI_LOGIN_URL} />
        <ProtectedRoute path="/orgs" component={OrgsPage} loginURL={process.env.REACT_APP_SSO_UI_LOGIN_URL} />
        <Redirect from="/" to="/users" />
      </Switch>
    </ContentAreaContainer>
  );
}

export default ContentArea;
